class NativeCouponMessage extends HTMLElement {
  connectedCallback() {
    const offer = this.querySelector('.coupon-text');
    const redemption = this.querySelector('.coupon-redemption');
    if (!offer || !redemption) return;

    this.resizeObserver = new ResizeObserver(() => {
      const offerBounds = offer.getBoundingClientRect();
      const codeBounds = redemption.getBoundingClientRect();
      // The separator is positioned outside the text flow to keep wrapping stable.
      this.toggleAttribute('data-code-wrapped', codeBounds.top >= offerBounds.bottom);
    });
    this.resizeObserver.observe(this);
    this.resizeObserver.observe(offer);
    this.resizeObserver.observe(redemption);
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }
}

if (!customElements.get('native-coupon-message')) {
  customElements.define('native-coupon-message', NativeCouponMessage);
}
